import React, { useState, useContext, useEffect } from "react";
import {
  Form,
  Button,
  Row,
  Col,
  Card,
  Carousel,
  Container,
} from "react-bootstrap";
import {
  FaTrash,
  FaBed,
  FaBath,
  FaRulerCombined,
  FaMapMarkerAlt,
} from "react-icons/fa";
import Select from "react-select";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { InfoContext } from "../providers/InfosContextProvider";
import { useNavigate, useLocation } from "react-router-dom";
import { buildPublicAssetPath } from "../utils/publicAssetPath";

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "#a02020"
      : state.isFocused
        ? "#f0f0f0"
        : "#ffffff",
    color: state.isSelected ? "#ffffff" : "#000000",
    "&:active": {
      backgroundColor: "#a02020",
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#000000",
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};

const Properties = () => {
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [selectedType, setSelectedType] = useState(null);
  const [selectedBedrooms, setSelectedBedrooms] = useState(null);
  const [selectedBathrooms, setSelectedBathrooms] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState(null);
  const { options, houses, texts } = useContext(InfoContext);

  useEffect(() => {
    const pageTitle =
      texts?.header?.segundo || texts?.header?.primeiro || "Imóveis";
    document.title = `${pageTitle} | Casas do Nabão`;
  }, [texts]);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const transaction = params.get("transaction");
    if (options.transaction.length > 0) {
      let selected;
      if (transaction) {
        selected = options.transaction.find((opt) => opt.value === transaction);
      } else {
        selected = options.transaction.find((opt) => opt.value === "comprar");
      }
      if (selected) {
        setSelectedTransaction(selected);
      }
    }
  }, [location.search, options.transaction]);

  useEffect(() => {
    if (options.sort && options.sort.length > 0 && !selectedFilter) {
      const defaultSort = options.sort.find((opt) => opt.value === "recente");
      if (defaultSort) {
        setSelectedFilter(defaultSort);
      }
    }
  }, [options.sort, selectedFilter]);

  const clearAllSelections = () => {
    setSelectedFilter(null);
    const params = new URLSearchParams(location.search);
    const transaction = params.get("transaction") || "comprar";
    const defaultTransaction = options.transaction.find(
      (opt) => opt.value === transaction,
    );
    setSelectedTransaction(defaultTransaction || null);
    setSelectedType(null);
    setSelectedBedrooms(null);
    setSelectedBathrooms(null);
  };

  const handleCardClick = (id) => {
    navigate(`/property/${id}`);
  };

  const sortProperties = (properties, filter) => {
    const sorted = [...properties];
    const parsePrice = (priceStr) => {
      if (!priceStr) return 0;
      const cleanStr = priceStr.replace(/[€\s.]/g, "").replace(",", ".");
      return parseFloat(cleanStr) || 0;
    };

    switch (filter) {
      case "recente":
        return sorted.sort((a, b) => b.id - a.id);
      case "antigo":
        return sorted.sort((a, b) => a.id - b.id);
      case "precoAsc":
        return sorted.sort((a, b) => parsePrice(a.valor) - parsePrice(b.valor));
      case "precoDesc":
        return sorted.sort((a, b) => parsePrice(b.valor) - parsePrice(a.valor));
      default:
        return sorted.sort((a, b) => b.id - a.id);
    }
  };

  const filterProperties = (properties) => {
    let filteredProperties = properties;

    if (selectedTransaction) {
      filteredProperties = filteredProperties.filter(
        (casa) => casa.transaction === selectedTransaction.value,
      );
    }
    if (selectedType) {
      filteredProperties = filteredProperties.filter(
        (casa) => casa.typeProperty === selectedType.value,
      );
    }
    if (selectedBedrooms) {
      filteredProperties = filteredProperties.filter(
        (casa) => casa.bedrooms === Number(selectedBedrooms.value),
      );
    }
    if (selectedBathrooms) {
      filteredProperties = filteredProperties.filter(
        (casa) => casa.bathrooms === Number(selectedBathrooms.value),
      );
    }

    return filteredProperties;
  };

  const filteredProperties = filterProperties(houses);

  return (
    <>
      <Header />
      <div
        className="fundo search-container"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/fundo.jpg)`,
        }}
      >
        <div className="search-content">
          <Form>
            <Row className="align-items-end">
              <Col className="inputs" md={6} lg={3}>
                <Form.Group controlId="type-transaction">
                  <Select
                    options={options.transaction}
                    value={selectedTransaction}
                    onChange={setSelectedTransaction}
                    styles={customStyles}
                    placeholder={`${texts.search.transaction}`}
                    isSearchable={false}
                    menuPortalTarget={document.body}
                  />
                </Form.Group>
              </Col>

              <Col className="inputs" md={6} lg={3}>
                <Form.Group controlId="type-property">
                  <Select
                    options={options.type}
                    value={selectedType}
                    onChange={setSelectedType}
                    styles={customStyles}
                    placeholder={`${texts.search.type}`}
                    isSearchable={false}
                    menuPortalTarget={document.body}
                  />
                </Form.Group>
              </Col>

              <Col className="inputs" md={6} lg={3}>
                <Form.Group controlId="bedrooms">
                  <Select
                    options={options.bedrooms}
                    value={selectedBedrooms}
                    onChange={setSelectedBedrooms}
                    styles={customStyles}
                    placeholder={`${texts.search.bedrooms}`}
                    isSearchable={false}
                    menuPortalTarget={document.body}
                  />
                </Form.Group>
              </Col>

              <Col className="inputs" md={6} lg={3}>
                <Form.Group controlId="bathrooms">
                  <Select
                    options={options.bathrooms}
                    value={selectedBathrooms}
                    onChange={setSelectedBathrooms}
                    styles={customStyles}
                    placeholder={`${texts.search.bathrooms}`}
                    isSearchable={false}
                    menuPortalTarget={document.body}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Col md={12} lg={12} className="text-right">
              <div className="icone-search">
                <Button className="btn-limpar" onClick={clearAllSelections}>
                  <FaTrash /> {`${texts.search.limpar}`}
                </Button>
              </div>
            </Col>
          </Form>
        </div>
      </div>

      <Container className="p-3">
        <div className="results">
          <Row className="results-container">
            <Col xs={6} md={6} className="text-start mb-2 mb-md-0">
              <span className="bold">{filteredProperties.length}</span>
              {`${texts.results.result}`}
            </Col>
            <Col xs={0} md={4} className="d-none d-md-block"></Col>
            <Col xs="auto" className="ms-auto sort-col">
              <Form.Group
                controlId="sort"
                className="d-flex justify-content-end"
              >
                <Select
                  options={options.sort}
                  value={selectedFilter}
                  onChange={setSelectedFilter}
                  styles={customStyles}
                  placeholder={`${texts.results.sort}`}
                  isSearchable={false}
                  className="sort-select"
                  classNamePrefix="select"
                  menuPortalTarget={document.body}
                />
              </Form.Group>
            </Col>
          </Row>
        </div>
        <Row>
          {sortProperties(
            filteredProperties,
            selectedFilter ? selectedFilter.value : null,
          ).map((casa) => (
            <Col key={casa.id} xs={12} md={6} lg={4} className="mb-4">
              <Card className="property-card">
                <Carousel interval={null} indicators={false}>
                  {casa.images.map((imagem, index) => (
                    <Carousel.Item key={index}>
                      <div className="property-imagem-container">
                        <img
                          src={buildPublicAssetPath(imagem)}
                          alt={`Casa ${casa.id}`}
                          onClick={() => handleCardClick(casa.id)}
                          loading="lazy"
                        />
                        <div className="property-valor">{casa.valor}</div>
                      </div>
                    </Carousel.Item>
                  ))}

                  <div className="properties-container">
                    {casa.efficiency.length === 1 ? (
                      <div className="property-efficiency">
                        <img
                          src={buildPublicAssetPath(
                            `/assets/images/efficiency/${casa.efficiency[0]}_RGB.png`,
                          )}
                          alt={`Eficiência Energética ${casa.efficiency[0]}`}
                        />
                      </div>
                    ) : (
                      casa.efficiency.map((imagem, index) => (
                        <Col key={index} xs={6} className="property-efficiency">
                          <img
                            src={buildPublicAssetPath(
                              `/assets/images/efficiency/${imagem}_RGB.png`,
                            )}
                            alt={`Eficiência Energética ${imagem}`}
                          />
                        </Col>
                      ))
                    )}
                  </div>
                </Carousel>

                <div className="property-info">
                  <Row>
                    <Col xs={12}>
                      <span>
                        <FaMapMarkerAlt /> {casa.localizacao}
                      </span>
                    </Col>
                  </Row>
                  <Row className="justify-content-center align-items-end">
                    {casa.area && (
                      <Col xs="auto">
                        <span>
                          <FaRulerCombined /> {casa.area}
                        </span>
                      </Col>
                    )}
                    {casa.bedrooms && (
                      <Col xs="auto">
                        <span>
                          <FaBed /> {casa.bedrooms}
                        </span>
                      </Col>
                    )}
                    {casa.bathrooms && (
                      <Col xs="auto">
                        <span>
                          <FaBath /> {casa.bathrooms}
                        </span>
                      </Col>
                    )}
                  </Row>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
      <Footer />
    </>
  );
};

export default Properties;
